import styled from "styled-components"

import { minWidth } from "utils"

export const Container = styled.div`
  align-items: center;
  p {
    font-size: 1.75rem;
    color: #222;
    font-weight: 500;
    margin: 0.25rem 0 2rem 1rem;
  }
  ${minWidth.tablet`
    display: flex;
  `}
  display: ${({ renderOnMobile }) => (renderOnMobile ? "flex" : "none")};
`

export const StarsContainer = styled.div`
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: ${({ isArticleProduct }) => (isArticleProduct ? "1.75rem" : "1.25rem")};
  margin: 0.25rem 0 ${({ isArticleProduct }) => (isArticleProduct ? "2rem" : "")} 0;
  position: relative;
  padding: 0;
  width: ${({ isArticleProduct }) => (isArticleProduct ? "11rem" : "7.85rem")};
  display: block;
`

export const Stars = styled.div`
  padding: 0;
  display: block;
  z-index: 0;
  span {
    overflow: hidden;
    width: max-content;
    display: inline-block;
  }
`

export const ColorStars = styled.div`
  width: ${({ rating }) => `${rating}%`};
  color: ${({ color }) => color || "#e7711b"};
  padding: 0;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  span {
    overflow: hidden;
    width: max-content;
    display: inline-block;
  }
`
